import { camelCase } from 'lodash';
import { MUI_ICONS } from './components/icons';
/**
 * Returns file path for the given icon name
 * @param iconName Icon for which the file path should be returned
 * @returns Path to the icon file
 */
export var getAccurityIconPath = function (iconName) {
    try {
        var iconFile = require("../../../src/images/icons/" + iconName + ".svg");
        if (!iconFile) {
            return null;
        }
        // Depending on webpack config, `iconFile` is
        // type string with value: <string of public path>
        // OR
        // type module with value: { default: <string of public path> }
        return typeof iconFile === 'string' ? iconFile : iconFile.default;
    }
    catch (e) {
        return null;
    }
};
/**
 * Checks whether the given icon name representes valid MUI icon
 * @param iconName Icon to be checked if is MUI icon
 * @returns TRUE if given icon is from MUI othervise FALSE
 */
export var isValidMuiIcon = function (iconName) {
    return Object.keys(MUI_ICONS).includes(iconName);
};
/**
 * Convert backend object-type iconName
 *
 * @param objectType snake-case object-type comming from backend (types should be narrowed to literals)
 * @return string objectType
 */
export function objectTypeToIconName(objectType) {
    return camelCase(objectType);
}
//# sourceMappingURL=utils.js.map